import React, { useEffect } from "react"
import Container from "./Container"
import Button from "./Button"
import logo from "../images/logo.svg"
import facebook_logo from "../images/facebook_logo.svg"
import instagram_logo from "../images/instagram_logo.svg"
import linkedin_logo from "../images/linkedin_logo.svg"
import twitter_logo from "../images/twitter_logo.svg"
import chevron_up from "../images/chevron_up.svg"
import message_logo from "../images/message_logo.svg"
import totop_icon from "../images/totop_icon.svg"
import aws_partner_badge from "../images/aws_partner_badge.svg"
import partner_of_the_year from "../images/partner_of_the_year.svg"
import { Link, navigate } from "gatsby"
import { FaPhoneAlt } from "react-icons/fa"

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional smooth scrolling behavior
    })
  }

  useEffect(() => {
    const script = document.createElement("script")
    // script.async = true
    // script.id = "zsiqscript"
    script.src = "//fw-cdn.com/11647239/4292187.js"
    script.chat = true
    // script.setAttribute("crossOrigin="anonymous"", "*")
    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [])

  //   <script
  // src='//fw-cdn.com/11647239/4292187.js'
  // chat='true'>
  // </script>

  return (
    <Container>
      <div
        onClick={scrollToTop}
        className=" cursor-pointer mt-[150px] flex flex-col justify-center items-center gap-2"
      >
        <img src={totop_icon} alt="" />
        <p className="quicksand text-[#3D41C2]">Back to top</p>
      </div>
      <div className="py-20">
        <hr className="mb-14 border-t border-[#2E3192]" />
        <div className="flex flex-col lg:flex-row">
          <div className="flex flex-col flex-1 mb-10">
            <div className="flex flex-col w-[80%]">
              <div className="w-[270px] mb-6">
                <img className="w-full" src={logo} alt="" />
              </div>
              <p className="quicksand mb-8 text-[#666666] text-[12px]">
                Created to accelerate business operations by helping them adopt
                DevOps best practices and implement technologies to assist this.
              </p>
            </div>
            <div className="w-[300px] lg:w-[150px] ">
              <Button onClick={() => navigate("/contactus")}>
                {" "}
                Talk to sales
              </Button>
            </div>
          </div>

          <div className="flex flex-col gap-3 mb-10 text-[14px] flex-1  lg:ml-6">
            <p className="mb-4">GET INFORMATION</p>
            <div className="flex gap-2 items-center">
              <div>
                <img src={message_logo} alt="" />
              </div>
              <a
                href="mailto:info@cognetiks.com"
                className="quicksand text-[#3D41C2]"
              >
                info@cognetiks.com
              </a>
            </div>

            <div className="mt-4 flex flex-col gap-2 quicksand text-[#666666]">
              <div>
                <p className="font-semibold text-[#121212]">UK Address</p>
                <p>Studio 2.24, Plaza 535 King's Road SW10 0SZ</p>
              </div>
              <div>
                <p className="font-semibold text-[#121212]">Nigerian Address</p>
                <p>29 Marina Rd, Lagos Island, Lagos 102273, Lagos, Nigeria</p>
              </div>
              <div className="mt-2">
                <p className="font-semibold text-[#121212]">Phone</p>
                <div className="flex flex-col mt-1 gap-1">
                  <a
                    href="tel:+447956223569"
                    className="text-[#3D41C2] flex items-center gap-2"
                  >
                    <FaPhoneAlt className="text-[#3D41C2]" />
                    <span>+44 7956 223569</span>
                  </a>
                  <a
                    href="tel:+2348101365433"
                    className="text-[#3D41C2] flex items-center gap-2"
                  >
                    <FaPhoneAlt className="text-[#3D41C2]" />
                    <span>+234 810 136 5433</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1  flex flex-col items-start lg:items-end text-[14px]">
            <p className="mb-6">FOLLOW US</p>
            <div className="flex gap-3 mb-6">
              <a
                href="https://www.facebook.com/Cognetiks-Consulting-102817557955137"
                target="_blank"
              >
                <img src={facebook_logo} alt="" />
              </a>
              <a href="https://twitter.com/CognetiksC" target="_blank">
                {" "}
                <img src={twitter_logo} alt="" />
              </a>

              <a
                href="https://www.linkedin.com/company/cognetiks-consulting"
                target="_blank"
              >
                <img src={linkedin_logo} alt="" />
              </a>
              <a
                href="https://www.instagram.com/cognetiks_consulting/"
                target="_blank"
              >
                <img src={instagram_logo} alt="" />
              </a>
            </div>
            <div className="flex items-center">
              <a
                href="https://aws.amazon.com/blogs/apn/announcing-the-2024-geo-and-global-aws-partners-of-the-year/"
                target="_blank"
                className="mb-4 w-[150px]"
              >
                <img src={partner_of_the_year} alt="" />
              </a>
              <a
                href="https://partners.amazonaws.com/partners/0010h00001d5BJOAA2/"
                target="_blank"
                className="mb-4"
              >
                <img src={aws_partner_badge} alt="" />
              </a>
            </div>
            <Link
              to={"/partners/aws"}
              className="flex justify-center items-center  gap-2 cursor-pointer"
            >
              <p className="text-[#121212] text-center ">
                Explore our AWS offerings
              </p>
              <img className="rotate-90" src={chevron_up} alt="" />
            </Link>
          </div>
        </div>

        <div>
          <hr className="my-10" />
          <div className="flex flex-col gap-6 lg:flex-row justify-between text-[14px]">
            <div className="flex gap-6">
              <Link to={"/aboutus"}>
                <p>ABOUT US</p>
              </Link>
              <Link to={"/contactus"}>
                <p>CONTACT US</p>
              </Link>
            </div>
            <p className="quicksand">
              Registered in England and Wales. - Company No. 12326521. - VAT No.
              GB342421730.
            </p>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Footer
